import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import ClickableElement from '../../ClickableElement';
import Icon from '../../Icon';
import { COLORS } from '../../../constants/styles';

import styles from './index.styl';

const Tooltip = ({
  content,
  open,
  close,
  top,
  left,
  right,
  bottom,
  width,
  onClose,
}) => (
  <div
    styleName={classNames('tooltip', {
      'tooltip--open': open,
      'tooltip--close': close,
    })}
    style={{
      top,
      left,
      right,
      bottom,
      width,
    }}
    onClick={e => e.stopPropagation()}
  >
    <div>{content}</div>
    <If condition={onClose}>
      <ClickableElement
        onClick={onClose}
        className="absolute top-0 right-0 pa3 br-100"
        hoverable
      >
        <Icon
          name="close"
          width={16}
          style={{
            transform: 'rotate(180deg)',
            stroke: COLORS.cloudyBlue,
          }}
        />
      </ClickableElement>
    </If>
  </div>
);

Tooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  open: PropTypes.bool,
  close: PropTypes.func,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func,
};

export default CSSModules(Tooltip, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Tooltip/index.jsx